export type FeatureType =
  | "pipe"
  | "object"
  | "waterLevel"
  | "hLine"
  | "vLine"
  | "label";
export const Features: Array<{ value: FeatureType; text: string }> = [
  { value: "object", text: "Object" },
  { value: "pipe", text: "Pipe" },
  { value: "waterLevel", text: "Water Level" },
  { value: "label", text: "Label" },
  { value: "hLine", text: "Horizontal Line" },
  { value: "vLine", text: "Vertical Line" }
];
export type FeaturePosition = "parallel" | "adjacent";
export const FeaturePositions: Array<{
  value: FeaturePosition;
  text: string;
}> = [
  { value: "parallel", text: "Parallel to Wall" },
  { value: "adjacent", text: "Adjacent to Wall" }
];
export type FeatureShape = "circle" | "rectangle";
export const FeatureShapes: Array<{ value: FeatureShape; text: string }> = [
  { value: "circle", text: "Circle" },
  { value: "rectangle", text: "Square / Rectangle" }
];
export type Alignment = "center" | "left" | "right";
export const Alignments: Array<{ value: Alignment; text: string }> = [
  { value: "center", text: "Center" },
  { value: "left", text: "Left" },
  { value: "right", text: "Right" }
];
export type Orientation = 0 | 90;
export const Orientations: Array<{ value: Orientation; text: string }> = [
  { value: 0, text: "Horizontal" },
  { value: 90, text: "Vertical" }
];
